import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vModelText as _vModelText, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5e18f130")

_pushScopeId("data-v-5e18f130")
const _hoisted_1 = {
  key: 0,
  class: "alert alert-danger mb-4"
}
const _hoisted_2 = {
  key: 0,
  class: "card-header border-0 pt-5"
}
const _hoisted_3 = { class: "card-title align-items-center" }
const _hoisted_4 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "Content calendar", -1)
const _hoisted_6 = { class: "d-flex flex-wrap align-items-center gap-3 mb-5" }
const _hoisted_7 = { class: "d-flex align-items-center gap-2" }
const _hoisted_8 = { class: "fw-semibold fs-5" }
const _hoisted_9 = { class: "d-flex flex-wrap align-items-center gap-2 ms-md-auto" }
const _hoisted_10 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_11 = { class: "d-flex flex-wrap gap-4 mb-6" }
const _hoisted_12 = { class: "fw-bold fs-4" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "text-muted fs-7" }, "Posted this month", -1)
const _hoisted_14 = { class: "fw-bold fs-4" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "text-muted fs-7" }, "Still scheduled", -1)
const _hoisted_16 = { class: "fw-bold fs-4" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "text-muted fs-7" }, "Need a retry", -1)
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "fw-bold fs-6" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "text-muted fs-7" }, "Engagement this month", -1)
const _hoisted_21 = { class: "d-flex flex-wrap align-items-center gap-2 mb-4" }
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "text-muted fs-8" }, " Auto-publish runs on the server for unedited drafts; posts may appear a few minutes after the scheduled time. ", -1)
const _hoisted_23 = { class: "content-calendar-grid mb-6" }
const _hoisted_24 = { class: "content-calendar-grid__day" }
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "content-calendar-video-preview__play content-calendar-video-preview__play--sm" }, [
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-play",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_26 = { class: "content-calendar-grid__caption" }
const _hoisted_27 = {
  key: 1,
  class: "text-muted fs-8"
}
const _hoisted_28 = {
  key: 0,
  class: "border rounded p-4"
}
const _hoisted_29 = { class: "mb-1" }
const _hoisted_30 = { class: "text-muted fs-7 mb-4" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "table-responsive" }
const _hoisted_33 = { class: "table align-middle gs-0 gy-3" }
const _hoisted_34 = { class: "fw-bold text-muted" }
const _hoisted_35 = /*#__PURE__*/_createVNode("th", {
  class: "ps-4",
  style: {"width":"72px"}
}, "Media", -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("th", null, "Time", -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("th", null, "Caption", -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("th", null, "Platforms", -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("th", null, "Status", -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("th", null, "Engagement", -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("th", null, "Accounts", -1)
const _hoisted_42 = {
  key: 0,
  class: "pe-4"
}
const _hoisted_43 = {
  key: 1,
  class: "pe-4"
}
const _hoisted_44 = { class: "ps-4" }
const _hoisted_45 = /*#__PURE__*/_createVNode("span", { class: "content-calendar-video-preview__play content-calendar-video-preview__play--sm" }, [
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-play",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_46 = {
  key: 2,
  class: "text-muted fs-8"
}
const _hoisted_47 = { class: "text-nowrap" }
const _hoisted_48 = /*#__PURE__*/_createVNode("label", { class: "social-post-page__label fs-8 mb-1" }, "Voiceover", -1)
const _hoisted_49 = { class: "badge badge-light-primary text-uppercase" }
const _hoisted_50 = { class: "text-muted fs-7" }
const _hoisted_51 = { class: "text-muted" }
const _hoisted_52 = { class: "pe-4" }
const _hoisted_53 = {
  key: 0,
  class: "d-flex flex-wrap gap-2"
}
const _hoisted_54 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_FillMyCalendarDialog = _resolveComponent("FillMyCalendarDialog")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock("div", null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", null, [
      (_ctx.loadError)
        ? (_openBlock(), _createBlock("div", _hoisted_1, _toDisplayString(_ctx.loadError), 1))
        : _createCommentVNode("", true),
      _createVNode("div", {
        class: _ctx.embedded ? '' : 'card seq-card mb-5'
      }, [
        (!_ctx.embedded)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("h3", _hoisted_3, [
                _createVNode("span", _hoisted_4, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/Clipboard.svg" })
                ]),
                _hoisted_5
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", {
          class: _ctx.embedded ? '' : 'card-body py-3'
        }, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("button", {
                type: "button",
                class: "btn btn-sm btn-light",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.shiftMonth(-1)))
              }, " Previous "),
              _createVNode("span", _hoisted_8, _toDisplayString(_ctx.monthLabel), 1),
              _createVNode("button", {
                type: "button",
                class: "btn btn-sm btn-light",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.shiftMonth(1)))
              }, " Next ")
            ]),
            _createVNode("div", _hoisted_9, [
              (_ctx.seriesStatusMessage)
                ? (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(_ctx.seriesStatusMessage), 1))
                : _createCommentVNode("", true),
              (_ctx.seriesDraftCount > 0 && !_ctx.publishingAll)
                ? (_openBlock(), _createBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn btn-sm btn-primary",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.publishAllSeriesDrafts && _ctx.publishAllSeriesDrafts(...args)))
                  }, " Publish all drafts "))
                : _createCommentVNode("", true),
              _createVNode("button", {
                type: "button",
                class: ["btn btn-sm", _ctx.filter === 'all' ? 'btn-primary' : 'btn-light'],
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.filter = 'all'))
              }, " All ", 2),
              _createVNode("button", {
                type: "button",
                class: ["btn btn-sm", _ctx.filter === 'posted' ? 'btn-primary' : 'btn-light'],
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.filter = 'posted'))
              }, " Posted ", 2),
              _createVNode("button", {
                type: "button",
                class: ["btn btn-sm", _ctx.filter === 'scheduled' ? 'btn-primary' : 'btn-light'],
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.filter = 'scheduled'))
              }, " Scheduled ", 2)
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("div", null, [
              _createVNode("div", _hoisted_12, _toDisplayString(_ctx.postedThisMonth), 1),
              _hoisted_13
            ]),
            _createVNode("div", null, [
              _createVNode("div", _hoisted_14, _toDisplayString(_ctx.scheduledThisMonth), 1),
              _hoisted_15
            ]),
            _createVNode("div", null, [
              _createVNode("div", _hoisted_16, _toDisplayString(_ctx.needsAttentionCount), 1),
              _hoisted_17
            ]),
            (_ctx.monthEngagementLabel !== '—')
              ? (_openBlock(), _createBlock("div", _hoisted_18, [
                  _createVNode("div", _hoisted_19, _toDisplayString(_ctx.monthEngagementLabel), 1),
                  _hoisted_20
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_21, [
            _createVNode("button", {
              type: "button",
              class: "btn btn-sm btn-light-primary",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.fillMyCalendarOpen = true))
            }, " Fill my calendar "),
            _hoisted_22
          ]),
          _createVNode("div", _hoisted_23, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.weekdayLabels, (label) => {
              return (_openBlock(), _createBlock("div", {
                key: label,
                class: "content-calendar-grid__head"
              }, _toDisplayString(label), 1))
            }), 128)),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.calendarCells, (cell, index) => {
              return (_openBlock(), _createBlock("div", {
                key: `cell-${index}`,
                class: ["content-calendar-grid__cell", {
                'content-calendar-grid__cell--empty': !cell.day,
                'content-calendar-grid__cell--today': cell.day === _ctx.todayDay && _ctx.isViewingCurrentMonth,
                'content-calendar-grid__cell--selected': cell.day === _ctx.selectedDay && cell.posts.length
              }],
                onClick: ($event: any) => (_ctx.selectDay(cell))
              }, [
                (cell.day)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _createVNode("div", _hoisted_24, _toDisplayString(cell.day), 1),
                      (cell.insightsCompact)
                        ? (_openBlock(), _createBlock("div", {
                            key: 0,
                            class: "content-calendar-grid__insights text-muted fs-8",
                            title: cell.insightsLabel
                          }, _toDisplayString(cell.insightsCompact), 9, ["title"]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(cell.posts.slice(0, 2), (post) => {
                        return (_openBlock(), _createBlock("div", {
                          key: post.id,
                          class: "content-calendar-grid__post"
                        }, [
                          (post.thumbnailUrl)
                            ? (_openBlock(), _createBlock("img", {
                                key: 0,
                                src: post.thumbnailUrl,
                                alt: "",
                                class: "content-calendar-grid__thumb"
                              }, null, 8, ["src"]))
                            : (post.videoUrl)
                              ? (_openBlock(), _createBlock("button", {
                                  key: 1,
                                  type: "button",
                                  class: "content-calendar-grid__video-thumb",
                                  "aria-label": `Play video for post ${post.id}`,
                                  onClick: _withModifiers(($event: any) => (_ctx.openVideoDialog(post)), ["stop"])
                                }, [
                                  _createVNode("video", {
                                    src: post.videoUrl,
                                    class: "content-calendar-grid__thumb",
                                    muted: "",
                                    playsinline: "",
                                    preload: "metadata"
                                  }, null, 8, ["src"]),
                                  _hoisted_25
                                ], 8, ["aria-label", "onClick"]))
                              : _createCommentVNode("", true),
                          _createVNode("span", _hoisted_26, _toDisplayString(post.captionSnippet), 1)
                        ]))
                      }), 128)),
                      (cell.posts.length > 2)
                        ? (_openBlock(), _createBlock("div", _hoisted_27, " +" + _toDisplayString(cell.posts.length - 2) + " more ", 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 10, ["onClick"]))
            }), 128))
          ]),
          (_ctx.selectedDayPosts.length)
            ? (_openBlock(), _createBlock("div", _hoisted_28, [
                _createVNode("h5", _hoisted_29, _toDisplayString(_ctx.selectedDayHeading), 1),
                _createVNode("p", _hoisted_30, [
                  _createTextVNode(_toDisplayString(_ctx.selectedDayPosts.length) + " post" + _toDisplayString(_ctx.selectedDayPosts.length === 1 ? "" : "s") + " on this day ", 1),
                  (_ctx.selectedDayEngagementLabel !== '—')
                    ? (_openBlock(), _createBlock("span", _hoisted_31, " · " + _toDisplayString(_ctx.selectedDayEngagementLabel), 1))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_32, [
                  _createVNode("table", _hoisted_33, [
                    _createVNode("thead", null, [
                      _createVNode("tr", _hoisted_34, [
                        _hoisted_35,
                        _hoisted_36,
                        _hoisted_37,
                        _hoisted_38,
                        _hoisted_39,
                        _hoisted_40,
                        _hoisted_41,
                        (_ctx.selectedDayHasSeriesDrafts)
                          ? (_openBlock(), _createBlock("th", _hoisted_42, "Draft actions"))
                          : (_openBlock(), _createBlock("th", _hoisted_43))
                      ])
                    ]),
                    _createVNode("tbody", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedDayPosts, (post) => {
                        return (_openBlock(), _createBlock("tr", {
                          key: post.id
                        }, [
                          _createVNode("td", _hoisted_44, [
                            (post.thumbnailUrl)
                              ? (_openBlock(), _createBlock("img", {
                                  key: 0,
                                  src: post.thumbnailUrl,
                                  alt: "",
                                  class: "content-calendar-detail__thumb"
                                }, null, 8, ["src"]))
                              : (post.videoUrl)
                                ? (_openBlock(), _createBlock("button", {
                                    key: 1,
                                    type: "button",
                                    class: "content-calendar-grid__video-thumb content-calendar-detail__thumb-wrap",
                                    "aria-label": `Play video for post ${post.id}`,
                                    onClick: _withModifiers(($event: any) => (_ctx.openVideoDialog(post)), ["stop"])
                                  }, [
                                    _createVNode("video", {
                                      src: post.videoUrl,
                                      class: "content-calendar-detail__thumb",
                                      muted: "",
                                      playsinline: "",
                                      preload: "metadata"
                                    }, null, 8, ["src"]),
                                    _hoisted_45
                                  ], 8, ["aria-label", "onClick"]))
                                : (_openBlock(), _createBlock("span", _hoisted_46, "—"))
                          ]),
                          _createVNode("td", _hoisted_47, _toDisplayString(post.timeLabel), 1),
                          _createVNode("td", null, [
                            (post.isSeriesDraft)
                              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                  _hoisted_48,
                                  _withDirectives(_createVNode("textarea", {
                                    "onUpdate:modelValue": ($event: any) => (_ctx.draftVoiceovers[post.id] = $event),
                                    class: "form-control form-control-sm",
                                    rows: "3",
                                    disabled: _ctx.publishingDraftId === post.id || _ctx.publishingAll,
                                    onBlur: ($event: any) => (_ctx.saveSeriesDraftVoiceover(post))
                                  }, null, 40, ["onUpdate:modelValue", "disabled", "onBlur"]), [
                                    [_vModelText, _ctx.draftVoiceovers[post.id]]
                                  ])
                                ], 64))
                              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(post.caption), 1)
                                ], 64))
                          ]),
                          _createVNode("td", null, _toDisplayString(post.platformsLabel), 1),
                          _createVNode("td", null, [
                            _createVNode("span", _hoisted_49, _toDisplayString(post.statusLabel), 1),
                            (post.isSeriesDraft && post.seriesDraftModeLabel)
                              ? (_openBlock(), _createBlock("span", {
                                  key: 0,
                                  class: ["badge ms-1", post.autoPublishEligible ? 'badge-light-success' : 'badge-light-warning']
                                }, _toDisplayString(post.seriesDraftModeLabel), 3))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("td", _hoisted_50, _toDisplayString(post.insightsLabel), 1),
                          _createVNode("td", _hoisted_51, _toDisplayString(post.accountsLabel), 1),
                          _createVNode("td", _hoisted_52, [
                            (post.isSeriesDraft)
                              ? (_openBlock(), _createBlock("div", _hoisted_53, [
                                  _createVNode("button", {
                                    type: "button",
                                    class: "btn btn-sm btn-light",
                                    disabled: _ctx.publishingAll || _ctx.publishingDraftId === post.id,
                                    onClick: ($event: any) => (_ctx.editSeriesDraft(post))
                                  }, " Edit ", 8, ["disabled", "onClick"]),
                                  _createVNode("button", {
                                    type: "button",
                                    class: "btn btn-sm btn-primary",
                                    disabled: _ctx.publishingAll || _ctx.publishingDraftId === post.id,
                                    onClick: ($event: any) => (_ctx.publishSeriesDraft(post))
                                  }, _toDisplayString(_ctx.publishingDraftId === post.id ? "Publishing…" : "Publish"), 9, ["disabled", "onClick"])
                                ]))
                              : (_openBlock(), _createBlock("span", _hoisted_54, "—"))
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ], 2),
      _createVNode(_component_FillMyCalendarDialog, {
        modelValue: _ctx.fillMyCalendarOpen,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.fillMyCalendarOpen = $event)),
        onStarted: _ctx.onFillSeriesStarted
      }, null, 8, ["modelValue", "onStarted"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.videoDialogVisible,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.videoDialogVisible = $event)),
        title: _ctx.videoDialogCaption || 'Video preview',
        width: "520px",
        "destroy-on-close": "",
        onOpened: _ctx.onVideoDialogOpened,
        onClosed: _ctx.onVideoDialogClosed
      }, {
        default: _withId(() => [
          (_ctx.videoDialogUrl)
            ? (_openBlock(), _createBlock("video", {
                key: 0,
                ref: "dialogVideo",
                src: _ctx.videoDialogUrl,
                class: "content-calendar-dialog-video",
                controls: "",
                playsinline: ""
              }, null, 8, ["src"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "title", "onOpened", "onClosed"])
    ], 512), [
      [_vShow, !_ctx.loading]
    ])
  ]))
})